import React, { useEffect, useState } from 'react';
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from '@mui/material';

export const GL_BRANCHES = [
  { code: '01', name: 'Portland' },
  { code: '02', name: 'Tri-Cities' },
  { code: '03', name: 'Seattle' },
  { code: '04', name: 'Spokane' },
  { code: '06', name: 'Alaska' },
  { code: '09', name: 'Corporate' }
];

export const GL_DEPARTMENTS = [
  { code: '10', name: 'Sales' },
  { code: '20', name: 'Service' },
  { code: '25', name: 'Testing' },
  { code: '27', name: 'Construction' },
  { code: '40', name: 'AST' },
  { code: '60', name: 'Mission Critical' },
  { code: '90', name: 'Corporate' }
];

export const GL_ACCOUNTS = [
  { code: '5400', name: 'Miscellaneous / COGS Misc.' },
  { code: '5520', name: 'Shop Supplies' },
  { code: '6169', name: 'Auto Expense / Tolls, Fees' },
  { code: '6240', name: 'Mechanical repairs to vehicles' },
  { code: '6337', name: 'Gifts, Storage, Fines, Hiring' },
  { code: '6340', name: 'Meals / Per Diem' },
  { code: '6351', name: 'Training Airfare / Lodging' },
  { code: '6352', name: 'Training Other' },
  { code: '6360', name: 'Travel / Entertainment' },
  { code: '6450', name: 'Technician Supplies / Tools' }
];

const codeIsKnown = (list, code) => list.some((item) => item.code === code);

export const partsFromGlCode = (code) => {
  const match = String(code || '').trim().match(/^(\d{2})-(\d{2})-(\d{4})$/);
  if (!match) {
    return { branch: '', department: '', account: '' };
  }
  return {
    branch: codeIsKnown(GL_BRANCHES, match[1]) ? match[1] : '',
    department: codeIsKnown(GL_DEPARTMENTS, match[2]) ? match[2] : '',
    account: codeIsKnown(GL_ACCOUNTS, match[3]) ? match[3] : ''
  };
};

export const composeGlCode = (branch, department, account) => `${branch}-${department}-${account}`;

const optionLabel = (item) => `${item.code} ${item.name}`;

const GLCodeField = ({
  value,
  onChange,
  disabled = false,
  label = 'GL Code',
  helperText = 'Choose branch, department, and category, or type a code.',
  idPrefix = 'gl'
}) => {
  const [branch, setBranch] = useState('');
  const [department, setDepartment] = useState('');
  const [account, setAccount] = useState('');

  useEffect(() => {
    const parts = partsFromGlCode(value);
    setBranch(parts.branch);
    setDepartment(parts.department);
    setAccount(parts.account);
  }, [value]);

  const updatePart = (part, code) => {
    const next = { branch, department, account, [part]: code };
    setBranch(next.branch);
    setDepartment(next.department);
    setAccount(next.account);
    if (next.branch && next.department && next.account) {
      onChange(composeGlCode(next.branch, next.department, next.account));
    }
  };

  const renderSelect = (id, selectLabel, selected, list, part) => (
    <FormControl fullWidth size="small" disabled={disabled}>
      <InputLabel id={`${id}-label`}>{selectLabel}</InputLabel>
      <Select
        labelId={`${id}-label`}
        label={selectLabel}
        value={selected}
        onChange={(event) => updatePart(part, event.target.value)}
      >
        <MenuItem value="">None</MenuItem>
        {list.map((item) => (
          <MenuItem key={item.code} value={item.code}>
            {optionLabel(item)}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );

  return (
    <Box>
      <Grid container spacing={1} sx={{ mb: 1 }}>
        <Grid item xs={12} sm={4}>
          {renderSelect(`${idPrefix}-branch`, 'Branch', branch, GL_BRANCHES, 'branch')}
        </Grid>
        <Grid item xs={12} sm={4}>
          {renderSelect(`${idPrefix}-department`, 'Department', department, GL_DEPARTMENTS, 'department')}
        </Grid>
        <Grid item xs={12} sm={4}>
          {renderSelect(`${idPrefix}-category`, 'Category', account, GL_ACCOUNTS, 'account')}
        </Grid>
      </Grid>
      <TextField
        fullWidth
        size="small"
        label={label}
        value={value || ''}
        onChange={(event) => onChange(event.target.value)}
        placeholder="01-20-6351"
        disabled={disabled}
        helperText={helperText}
      />
    </Box>
  );
};

export default GLCodeField;
